<template id="revision">
	<li class="revisions-item" :class="{ 'revisions-item-current': isCurrent }">
		<a :href="revision.permalink">
			<img :src="revision.author_avatar" :alt="revision.author_name" class="revisions-item-avatar" />

			<div class="revisions-item-content">
				<h5>
					<strong>{{ revision.token }}</strong> by {{ revision.author_name }}
				</h5>

				<p>{{ revision.updated_ago }}</p>
			</div>
		</a>
	</li>
</template>

<script>

export default {
    props: {
        revision: {
            type: Object,
            required: true
        },
        isCurrent: {
            type: Boolean,
            required: true
        }
    },
}
</script>